import React, { useCallback, useEffect, useState } from "react";
import { useHistory } from "react-router-dom";

import {
  GQL_ERROR,
  GQL_FETCH_POLICY_NETWORK_ONLY,
  HTTP_TIMEOUT_ERROR_CODE,
  URI_PATHS,
} from "../../../constants";
import {
  DECISION_AWAITING_USER_RESPONSE,
  DECISION_ERROR,
  DECISION_PENDING,
} from "./constants";

import { usePromisedLazyQuery } from "../../../state/store/customHooks";
import { GET_DECISION } from "./gql";
import { GET_APPLICATION_INFO } from "../../../api/gql";

import DetermineScreen from "./DetermineScreen";
import withQuery from "../wrappers/gql/withQuery";

const DecisionV2 = ({ data: applicationInfo }) => {
  const history = useHistory();
  const { applicationStatus } = applicationInfo.getApplicationInfo;
  const [ decisionStatus, setDecisionStatus] = useState(applicationStatus);
  const [ getDecision ] = usePromisedLazyQuery(GET_DECISION, GQL_FETCH_POLICY_NETWORK_ONLY);

  const _initializeStep = useCallback(async () => {
    if(
      decisionStatus &&
      decisionStatus !== DECISION_AWAITING_USER_RESPONSE &&
      decisionStatus !== DECISION_PENDING
    ) return;

    let decisionResults;
    try {
      decisionResults = await getDecision();
    } catch (err) {
      // If this call times out, it's likely decision is taking longer than 2 min. So
      // tell user to check back again later
      if(err.statusCode === HTTP_TIMEOUT_ERROR_CODE){
        setDecisionStatus(DECISION_PENDING);
        return;
      }

      setDecisionStatus(DECISION_ERROR);
      return;
    }

    const {
      applicationDecision,
      status,
    } = decisionResults.runDecision;

    if(status === GQL_ERROR){
      setDecisionStatus(DECISION_ERROR);
      return;
    }

    // Note: In order for us to send users to conditional approval, we strictly rely on application
    // status instead of also looking at "meetsBalanceThreshold". They should both be the same thing.
    if(applicationDecision === DECISION_AWAITING_USER_RESPONSE){
      history.push(URI_PATHS.PREAPPROVAL_DASHBOARD);
      return;
    }

    setDecisionStatus(applicationDecision);
  }, []);

  useEffect(() => {
    _initializeStep();
  }, []);

  return (
    <div className="outerStack-mobile sm:outerStack">
      <DetermineScreen decisionStatus={decisionStatus} />
    </div>
  );
};

export default withQuery(GET_APPLICATION_INFO)(DecisionV2);
